// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-button-view[data-v-6d09bfde]{width:80px}.color-icon[data-v-6d09bfde]{width:60px}", ""]);
// Exports
module.exports = exports;
